import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListTariffCell } from './channel-list-tariff.cell';
import { ChannelListTariffHeader } from './channel-list-tariff.header';

export const ChannelListTariffColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['tariff']
> = {
  enableSorting: false,
  header: ChannelListTariffHeader,
  cell: ChannelListTariffCell,
};
